import { setConfigMode } from '@qapline/config';
import { env } from 'env';

setConfigMode(env.VITE_MODE);
